/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getSelectedTextQuads__anchor
 */
export default () => window.documentViewer.getSelectedTextQuads();
